<div class="login-wrapper">
  <img *ngIf="backgroundImage" class="app-background" [src]="backgroundImage">
  <div class="login-container">
    <div class="login-header" *ngIf="logo">
      <mat-icon class="eidos-icon eidos-svg-icon" [svgIcon]="logo.iconCode" style="transform: scale(7);"></mat-icon>
    </div>
    <router-outlet></router-outlet>
    <button mat-raised-button color="primary" (click)="goToReturnUrl()">Home</button>   
  </div>
</div>